import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import Cta from "@qlik/qlik/src/components/Cta";
import ImageCard from "@qlik/qlik/src/components/Card/Single-Card-Image";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import formatContentfulRichText from "@qlik/qlik/src/lib/format-rich-text-content";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import * as styles from "./styles.module.css";

const ContentBlocksWithButtons = ({ data }) => {
    const {
        id,
        customId,
        additionalConfiguration,
        title,
        body,
        cardItems = [],
        cta = [],
        backgroundColor,
        numberOfColumns,
    } = data ?? {};
    const spacingClassName = getSpacingClassName(additionalConfiguration, "py-10 lg:py-30");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const isImageFull = false;
    const bodyDescription = true;
    return (
        <section id={customId || id} className={`${spacingClassName}  ${sectionColorMapping.bgColor} gartner-cards`}>
            <div className="container">
                {title && (
                    <h2
                        className={`${sectionColorMapping.primaryTextColor} mb-5 title-2 text-left lg:text-center lg:tracking-tight10`}
                    >
                        {title}
                    </h2>
                )}

                {body?.raw && (
                    <div className="text-center flex justify-center">
                        <div
                            className={`${sectionColorMapping.primaryTextColor} ${styles.description} text-sm md:text-md tracking-tight1-l font-light lg:tracking-tight6 text-left lg:text-center lg:text-2xl md:leading-relaxed`}
                        >
                            {renderRichText(data.body, formatContentfulRichText())}
                        </div>
                    </div>
                )}
                <div
                    className={`card-wrapper ${styles.cardWrapper} grid gap-5 py-10 lg:py-20 lg:gap-7.5 ${
                        numberOfColumns === null ? "md:grid-cols-3" : `md:grid-cols-${numberOfColumns}`
                    }`}
                >
                    {cardItems?.map((card) => (
                        <ImageCard
                            data={card}
                            key={card.id}
                            isGridTight={numberOfColumns && numberOfColumns > 3}
                            isImageFull={isImageFull}
                            bodyDescription={bodyDescription}
                        />
                    ))}
                </div>
                {cta && (
                    <div className="section-cta flex gap-5 flex-col md:flex-row justify-center items-center">
                        {cta.map((button) => (
                            <Cta key={button.id} data={button} className="tracking-normal" />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default ContentBlocksWithButtons;
